<template>
  <div class="card shadow-none base-performance">
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between gap-4px">
        <div class="text-xl text-default">{{ title }}</div>
        <slot name="card-tools"></slot>
      </div>
      <div class="mt-15px">
        <empty-chart v-if="empty"></empty-chart>
        <div v-else>
          <slot
            :seleted-date="selectedDate"
          ></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import MultilevelDateSelect from "@/components/inputs/multilevel-date-select.vue";

import EmptyChart from "@/router/views/dashboards/components/empty-chart.vue";

export default {
  name: "base-performance",
  components: {EmptyChart},
  // components: {MultilevelDateSelect},
  props: {
    title: {
      type: String,
      default: "Performance",
    },
    empty: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      selectedDate: 'Q1 2023'
    }
  }
}
</script>